import { Link } from 'react-router-dom';

// Regex pour détecter les URLs
const urlRegex = /(https?:\/\/[^\s]+)/g;

// Regex pour détecter les mentions @nom
const mentionRegex = /@(\w+)/g;

/**
 * Parse le texte d'un commentaire et rend les liens cliquables
 */
export function parseLinks(text) {
  if (!text) return text;
  
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = urlRegex.exec(text)) !== null) {
    // Ajouter le texte avant le lien
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: text.substring(lastIndex, match.index) });
    }
    
    // Ajouter le lien
    const url = match[0];
    parts.push({
      type: 'link',
      content: url,
      url: url.startsWith('http') ? url : `https://${url}`,
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Ajouter le reste du texte
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.substring(lastIndex) });
  }
  
  return parts.length > 0 ? parts : [{ type: 'text', content: text }];
}

/**
 * Parse le texte et extrait les mentions avec leurs IDs
 * Format stocké: @[nom](id)
 */
export function parseMentions(text, hairstylists = []) {
  if (!text) return { text, mentions: [] };
  
  const mentions = [];
  let processedText = text;
  
  // Chercher les mentions au format @[nom](id)
  const mentionWithIdRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
  let match;
  
  while ((match = mentionWithIdRegex.exec(text)) !== null) {
    mentions.push({
      id: match[2],
      name: match[1],
      start: match.index,
      end: match.index + match[0].length,
    });
  }
  
  return { text: processedText, mentions };
}

/**
 * Rendre le texte avec les liens et mentions cliquables
 */
export function renderCommentText(text, mentions = [], onMentionClick) {
  if (!text) return [{ type: 'text', content: '' }];
  
  const parts = [];
  let lastIndex = 0;
  
  // D'abord, traiter les mentions (elles ont priorité)
  const mentionWithIdRegex = /@\[([^\]]+)\]\(([^)]+)\)/g;
  let match;
  const mentionMatches = [];
  
  while ((match = mentionWithIdRegex.exec(text)) !== null) {
    mentionMatches.push({
      type: 'mention',
      start: match.index,
      end: match.index + match[0].length,
      name: match[1],
      id: match[2],
    });
  }
  
  // Ensuite, traiter les URLs
  const urlMatches = [];
  urlRegex.lastIndex = 0;
  while ((match = urlRegex.exec(text)) !== null) {
    // Vérifier que l'URL n'est pas dans une mention
    const isInMention = mentionMatches.some(
      (m) => match.index >= m.start && match.index < m.end,
    );
    if (!isInMention) {
      urlMatches.push({
        type: 'link',
        start: match.index,
        end: match.index + match[0].length,
        url: match[0],
      });
    }
  }
  
  // Fusionner et trier tous les matches
  const allMatches = [...mentionMatches, ...urlMatches].sort((a, b) => a.start - b.start);
  
  allMatches.forEach((match) => {
    // Ajouter le texte avant le match
    if (match.start > lastIndex) {
      parts.push({ type: 'text', content: text.substring(lastIndex, match.start) });
    }
    
    // Ajouter le match
    if (match.type === 'mention') {
      parts.push({
        type: 'mention',
        name: match.name,
        id: match.id,
      });
    } else if (match.type === 'link') {
      parts.push({
        type: 'link',
        url: match.url.startsWith('http') ? match.url : `https://${match.url}`,
        content: match.url,
      });
    }
    
    lastIndex = match.end;
  });
  
  // Ajouter le reste du texte
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.substring(lastIndex) });
  }
  
  return parts.length > 0 ? parts : [{ type: 'text', content: text }];
}

